import dashboard from './menu/dashboard'
import administrator from './menu/administrator'
import rolePermission from './menu/rolePermission'
import company from './menu/company'
import senior from './menu/senior'
import master from './menu/master'
import agent from './menu/agent'
import player from './menu/player'
import assistant from './menu/assistant'
import transaction from './menu/transaction'
import balanceReport from './menu/balanceReport'
import parley from './menu/parley'
import liveBetting from './menu/liveBetting'
import requestDeposit from './menu/requestDeposit'
import requestWithdraw from './menu/requestWithdraw'
import setting from './menu/setting'
import loyalty from './menu/loyalty'
import baccarat from './menu/baccarat'
import report from './menu/report'
import bank from './menu/bank'
import matchVideo from './menu/matchVideo'
import vvipReport from './menu/vvipReport'

export default [
  ...dashboard,
  ...administrator,
  ...rolePermission,
  ...liveBetting,
  ...baccarat,
  ...parley,
  ...company,
  ...senior,
  ...master,
  ...agent,
  ...player,
  ...assistant,
  ...transaction,
  ...balanceReport,
  ...report,
  ...vvipReport,
  ...requestDeposit,
  ...requestWithdraw,
  ...setting,
  ...loyalty,
  ...bank,
  ...matchVideo,
]
